import {
  buildDraftPayload,
  createDraftApiClient,
  installPhase3Bridge
} from "./legacy-field-bridge";
import { createFormFieldAdapter, installFormFieldAdapter } from "./adapters/mds-form-field";
import { collectContainerValues, toNullableEmail } from "./form/payload";

const publicApi = {
  buildDraftPayload,
  collectContainerValues,
  createDraftApiClient,
  createFormFieldAdapter,
  installFormFieldAdapter,
  installPhase3Bridge,
  toNullableEmail
};

if (typeof globalThis !== "undefined") {
  (globalThis as typeof globalThis & { NewformsPhase3?: typeof publicApi }).NewformsPhase3 = publicApi;
}

export * from "./legacy-field-bridge";
export * from "./adapters/mds-form-field";
export * from "./api/draft";
export * from "./form/payload";
